import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { loginedSelector } from '../../Redux/Reducers/authReducer';
import { LoginPage } from './Pages/LoginPage/LoginPage';
import { OrdersPage } from './Pages/OrdersPage/OrdersPage';
import { ProfilePage } from './Pages/ProfilePage/ProfilePage';
import { AddProductPage } from './Pages/AddProductPage/AddProductPage';
import { CategoriesPage } from './Pages/CategoriesPage/CategoriesPage';
import { ProductsPage } from './Pages/ProductsPage/ProductsPage';
import { ReportsPage } from './Pages/ReportsPage/ReportsPage';
import { HomePage } from './Pages/HomePage/HomePage';

interface StateProps {
  logined: boolean
}
interface Props extends StateProps { }

function Routes(props: Props) {
  function renderLoginedRoutes() {
    return (
      <>
        <Route path='/' exact>
          <HomePage />
        </Route>
        <Route path='/reports' exact>
          <ReportsPage />
        </Route>
        <Route path='/orders' exact>
          <OrdersPage />
        </Route>
        <Route path='/products' exact>
          <ProductsPage />
        </Route>
        <Route path='/addproduct' exact>
          <AddProductPage />
        </Route>
        <Route path='/categories' exact>
          <CategoriesPage />
        </Route>
        <Route path='/profile' exact>
          <ProfilePage />
        </Route>
        <Redirect to='/' />
      </>
    );
  }
  function renderUnloginedRouter() {
    return (
      <>
        <Route path='/login'>
          <LoginPage />
        </Route>
        <Redirect to='/login' />
      </>
    );
  }
  return (
    <Switch>
      {
        props.logined
          ? renderLoginedRoutes()
          : renderUnloginedRouter()
      }
    </Switch>
  );
}

function mapStateToProps(state: any) {
  return {
    logined: loginedSelector(state)
  }
}

const ConnectedRoutes = connect(mapStateToProps)(Routes);

export { ConnectedRoutes as Routes };